import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { ServerOverviewVulnerability } from '../../../components/servers-grid/server-overview-vulnerability'
import { ServerOverviewVulnerabilityProps } from '../../../components/servers-grid/api/use-server-vuln-info'

function ServerOverviewVulnerabilityBridge({
  assessServer,
  lastUpdatedTimestamp,
  orgUuid,
  serverId,
  violations,
  vulnCount
}: ServerOverviewVulnerabilityProps) {
  return (
    <ServerOverviewVulnerability
      assessServer={assessServer}
      lastUpdatedTimestamp={lastUpdatedTimestamp}
      orgUuid={orgUuid}
      serverId={serverId}
      violations={violations}
      vulnCount={vulnCount}
    />
  )
}

export const reactServerOverviewVulnerability = createNgReactBridgeDirective(
  'reactServerOverviewVulnerability',
  [],
  ServerOverviewVulnerabilityBridge,
  [
    'assessServer',
    'lastUpdatedTimestamp',
    'orgUuid',
    'serverId',
    'violations',
    'vulnCount'
  ]
)
